<!--
 * @Author: wsx
 * @Date: 2022-02-28 16:58:03
 * @LastEditTime: 2022-02-28 17:47:27
 * @Description:图层
 * @FilePath: \hz-digital-twin\src\layout\components\MyLayer\index.vue
-->
<template>
  <div class="MyLayer">
    <ul class="layer-types">
      <template v-for="i in layerTypes" :key="i.id">
        <li
          class="layer-type"
          @click="clickLayerType(i)"
          :class="{ select: !i.select }"
        >
          <div class="layer-icon">
            <h-icon :icon="i.icon" font-size="26"></h-icon>
          </div>
          <div class="layer-label">{{ i.name }}</div>
        </li>
      </template>
    </ul>
  </div>
</template>
<script>
import { defineComponent, reactive, toRefs } from "vue";
export default defineComponent({
  name: "MyLayer",
  setup(props) {
    const state = reactive({
      layerTypes: [
        {
          id: 1,
          name: "房屋",
          icon: "icon-hongwai",
          select: true,
        },
        {
          id: 2,
          name: "单位",
          icon: "icon-jiankong",
          select: true,
        },
        {
          id: 3,
          name: "安防设施",
          icon: "icon-gis_shendujiancetoushi",
          select: true,
        },
      ],
    });
    const refData = toRefs(state);
    const clickLayerType = (row) => {
      row.select = !row.select;
    };
    return { ...refData, clickLayerType };
  },
});
</script>
<style  lang='scss' scoped >
.MyLayer {
  position: fixed;
  bottom: 240px;
  right: 500px;
  z-index: 999;
  .layer-types {
    @include flex-col-e-c;
    .layer-type {
      cursor: pointer;
      margin-top: 10px;
      @include flex-col-c-c;
      $colors: #ae9a4c, #1799c6, #20a69c;
      @each $c in $colors {
        $i: index($colors, $c);
        &:nth-child(#{$i}) .layer-icon {
          background-color: $c;
        }
      }
      &.select {
        opacity: 0.4;
      }
      .layer-icon {
        border-radius: 50%;
        width: 50px;
        height: 50px;
        position: relative;
        margin-bottom: 15px;
        @include flex-col-c-c;
        &::after {
          position: absolute;
          bottom: -10px;
          content: "";
          width: 100%;
          height: 50%;
          background-image: url("~@/assets/images/index/ellipse.png");
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
